/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Phonenumber API allows you to manage your phone numbers including assign metadata and group numbers together
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MetaData interface.
 */
export function instanceOfMetaData(value) {
    return true;
}
export function MetaDataFromJSON(json) {
    return MetaDataFromJSONTyped(json, false);
}
export function MetaDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isoCountry': json['isoCountry'] == null ? undefined : json['isoCountry'],
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
    };
}
export function MetaDataToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isoCountry': value['isoCountry'],
        'countryName': value['countryName'],
    };
}
